<md-content-box class="lesson-block" [type]="isProjectFinalGradeInvalid() ? 'error' : 'default'">
	<md-icon icon="untitled-ui/files/clipboard-check"></md-icon>
	<div class="lesson-block__body">
		<div class="lesson-block__header">
			<div class="lesson-block__title">
				<md-header size="xs">Project Semester Results</md-header>
				<span md-tooltip="Required grade" class="required">*</span>
			</div>

			<div class="lesson-block__actions">
				<!-- Reference for everyone who can see the grades; the dialog is display-only. -->
				@if (projectCriteria().length > 0) {
					<button md-button class="view-rubrics-btn" (click)="openRubricDialog()">View Rubric</button>
				}
				@if (canGrade()) {
					<button md-button-brand (click)="openProjectGradeDialog()">{{ gradeButtonText() }}</button>
				}
			</div>
		</div>

		<div class="lesson-block__content">
			@if (projectCategory(); as category) {
				<div class="project-final__milestones">
					@for (criteria of projectCriteria(); track criteria.criteriaID) {
						<div class="project-final__milestone">
							<span class="project-final__milestone-name">{{ criteria.criteriaName }} ({{ criteria.weightPercent }}%)</span>
							@if (criteriaGradeMap()[criteria.criteriaID]; as gradeInfo) {
								<lb-grade-tag [grade]="gradeInfo.gradeName" [type]="gradeInfo.color"></lb-grade-tag>
							} @else {
								<lb-grade-tag grade="—" type="disabled"></lb-grade-tag>
							}
						</div>
					}
				</div>

				<div class="project-final__overall">
					<span class="project-final__overall-label">Overall Project Grade</span>
					@if (overallGrade(); as grade) {
						<lb-grade-tag [grade]="grade.gradeName" [type]="overallGradeColor()"></lb-grade-tag>
					} @else {
						<lb-grade-tag grade="—" type="disabled"></lb-grade-tag>
					}
				</div>
			} @else {
				<p class="project-final__empty">No project category configured for this enrollment.</p>
			}
		</div>
	</div>
</md-content-box>
